// import { enqueueSnackbar } from 'notistack';

// const getVariant = status => {
//     const variants = {
//         200: 'success',
//         201: 'success',
//         success: 'success',
//         error: 'error',
//         warning: 'warning',
//         info: 'info',
//         default: 'default',
//     };
//     return variants[status] || 'default';
// };

// const showMessage = (message, status) => {
//     const variant = getVariant(status);
//     return enqueueSnackbar(message, { variant });
// };

// export default showMessage;
import { enqueueSnackbar, VariantType } from 'notistack';

// const getVariant = (status: string | number): VariantType => {
//     const variants: { [key: string]: VariantType } = {
//         200: 'success',
//         201: 'success',
//         success: 'success',
//         error: 'error',
//         warning: 'warning',
//         info: 'info',
//         default: 'default',
//     };
//     return variants[status];
// };

const showMessage = (message: string, variant: VariantType = 'success'): void => {
    // const variant: VariantType = getVariant(status);
    enqueueSnackbar(message, { variant });
};

export default showMessage;
